import React, { useContext } from 'react';
import { useModal } from '../ModalContext';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Modal.module.scss';
import SvgCross from '../../kit/icons/Cross';

interface ModalProps {
    id: string;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
    id,
    children,
    ...props
}) => {
    const st: CssModuleType = currentCssModule;
    const { closeModal } = useModal();

    return (
        <div className={st['modal-overlay']} onClick={() => closeModal(id)}>
            <div
                className={st['modal-content']}
                onClick={(e) => e.stopPropagation()}
            >
                <SvgCross
                    className={st['modal-close']}
                    size={12}
                    onClick={() => closeModal(id)}
                />
                {children}
            </div>
        </div>
    );
};

export default Modal;
